import React from 'react';
import StageDetailsLogo from './StageDetailsLogo';

export default function StageDateLogo() {
  return (
    <StageDetailsLogo
      imgSrc="general/calendar.svg"
      altText="Calendar Icon"
      width={12}
    />
  );
}
